// The three evaluation slices, side by side, each stating what a result on
// that slice may and may not be taken to mean. All three are readable at
// once: nothing here is worth hiding behind a control.

const SLICES = [
  {
    id: "clean",
    label: "No action change",
    what: "The agent acts on its own. We do not change any of its actions.",
    may: "Does training on recovery examples also help on the ordinary task?",
    maynot:
      "The agent can still make its own mistakes. This is the study’s clean condition.",
  },
  {
    id: "matched",
    label: "Familiar change",
    what: "We change one action using the same mapping and timing as recovery training, but in new test scenarios.",
    may: "Can the agent handle the kind of change it trained on?",
    maynot:
      "The study calls this matched corruption. The mazes are held out; the action-change rules are familiar.",
  },
  {
    id: "unseen",
    label: "New change",
    what: "We use a different mapping between actions and change them at times not used in recovery training.",
    may: "Does the benefit carry over to this new pattern of errors? This is the main comparison.",
    maynot:
      "The study calls this unseen corruption. It tests one new mapping, so it cannot establish robustness to every kind of failure.",
  },
] as const;

export function renderSliceExplainer(mount: HTMLElement): void {
  const wrapper = document.createElement("div");
  wrapper.className = "slice-cards";
  wrapper.innerHTML = SLICES.map(
    (slice) => `
      <article class="slice-card" data-slice="${slice.id}">
        <h3>${slice.label}</h3>
        <p>${slice.what}</p>
        <p class="slice-card__question">${slice.may}</p>
        <p class="slice-card__note">${slice.maynot}</p>
      </article>`,
  ).join("");
  mount.replaceChildren(wrapper);
}
